//third party
import { useAtom } from "jotai";
import { useForm } from "react-hook-form";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { Alert, Card } from "react-bootstrap";
import { Asterisk, At } from "react-bootstrap-icons";

//spotsync
import { Button } from "./Controls/Button";
import { authAtom, authTokenAtom, redirectAtom } from "./Data/Atoms";
import { useState } from "react";
import { HeaderText } from "./Controls/HeaderText";
import { CenteredPage } from "./Controls/CenteredPage";
import { Input } from "./Controls/Input";
import { AuthApi, StaffApi } from "./shared/api/axios-client";

import { createApiService, getOrCreateDeviceId } from "./shared/apiConfig";
import { getJwtRoles } from "./helpers/JwtDecoder";
import { extractClaims, getDefaultRedirectPath } from "./helpers/AuthorizationManager";
import { Operator } from "./Data/ApiTypes";
import { clearLocalStoragePreserving, STORAGE_GROUPS } from "./shared/localStorageHelper";

export const LogInPage = () => {
    const op = useLoaderData() as Operator;
    const [auth, setAuth] = useAtom(authAtom);
    const [authToken, setAuthToken] = useAtom(authTokenAtom);
    const [errMsg, setErrMsg] = useState<string>();
    const [isLoading, setIsLoading] = useState(false);
    const nav = useNavigate();
    const authApi = createApiService(AuthApi);
    const [redirect, setRedirect] = useAtom(redirectAtom);

    interface LogInForm {
        emailAddress: string;
        password: string;
    }

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<LogInForm>();

     

    function submit(data: LogInForm) {
        setIsLoading(true);
        clearLocalStoragePreserving([STORAGE_GROUPS.reporting]);
        const username = `${data.emailAddress}`;
        const deviceId = getOrCreateDeviceId();
        authApi.login({
            serverServicesIntegrationsAccountLoginRequestModel: {
                userName: username,
                password: data.password,
                deviceId: deviceId,
            } as any
        } as any, {
            params: {
                hasToken: false
            },
            withCredentials: true // ensure we receive HttpOnly refresh token cookie
        }).then(
            res => {                
                if (res.data.userNotFound == false) {
                    const staffId = res.data.spotSyncUserId!
                    const accessToken = res.data.accessToken!;
                    setAuthToken({ accessToken });
                    const roles = getJwtRoles(accessToken);
                    // Update here to get custom claims in future
                    const staffApi = createApiService(StaffApi);
                    staffApi.getStaff({
                        id: staffId
                    }).then((staffResponse)=>{
                        setAuth({isLoggedIn: true, account: staffResponse.data.item as any, accessToken, roles});

                        if (redirect) {
                            const path = redirect;
                            setRedirect(undefined);
                            nav(path);
                        } else {
                            const auth = { isLoggedIn: true, account: staffResponse.data.item as any, accessToken, roles };
                            nav(getDefaultRedirectPath(extractClaims(auth)));
                        }
                    });                   
                } else {
                    setErrMsg("Email or password is incorrect")
                }
                

            }).catch((err) =>
                setErrMsg(err.response?.data?.message || "An error occurred while logging in.")

            ).finally(() => setIsLoading(false))


    }

    return <CenteredPage sm="10" md="8" lg="6" xl="4" style={{ maxWidth: "30em" }}>
       <div className="d-flex flex-column align-items-center w-100">
        {op.logoUrl && (
        <div className="text-center mb-4">
            <img
            width={150}
            style={{ maxHeight: "150px" }}
            src={op.logoUrl}
            alt={`${op.name} Logo`}
            className="m-4"
            />
        </div>
        )}
        <Card className="w-100">
            <form onSubmit={handleSubmit(submit)}>
                <Card.Header>
                    <HeaderText>Log In</HeaderText>
                </Card.Header>
                <Card.Body className="py-4">
                    <Input
                        type="email"
                        label="Email Address"
                        icon={<At className="fs-5" />}
                        placeholder="Enter your email"
                        error={errors.emailAddress}
                        {...register("emailAddress", { required: "Email Address is required" })}
                    />
                    <Input
                        type="password"
                        label="Password"
                        icon={<Asterisk className="fs-6" />}
                        placeholder="Enter your password"
                        error={errors.password}
                        {...register("password", { required: "Password is required" })}
                    />
                    {errMsg && (
                        <Alert variant="danger" className="text-danger">
                            {errMsg}
                        </Alert>
                    )}
                    <div>
                        <Link to="/forgot">Forgot Password</Link>
                    </div>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex flex-row justify-content-end gap-2">
                        <Button className="w-100" onClick={() => nav("/")}>
                            Back
                        </Button>
                        <Button type="submit" loading={isLoading} className="w-100 btn-main">
                            Log In
                        </Button>
                    </div>
                </Card.Footer>
            </form>
        </Card>
        </div>
    </CenteredPage>;
};
